import React, { useContext } from "react";
import { EditReservationContext } from "./EditReservationContext";


export default function ReservationStudentSearch() {
  const c = useContext(EditReservationContext);
  if (!c) return null;
  return (
    <div className="editReservationPopup__group-body">
       <div className="editReservationPopup__search-header">
          <input
             type="text"
             className="editReservationPopup__search-input"
             placeholder="Caută elev"
             value={c.qStudent}
             onChange={(e) => c.setQStudent(e.target.value)}
          />
          <button
             className="editReservationPopup__btn editReservationPopup__btn--normal"
             onClick={() => c.setView("form")}
          >
             Înapoi
          </button>
       </div>

       <div className="editReservationPopup__search-list-wrapper">
          <ul className="editReservationPopup__search-list">
             {c.filteredStudents.map((s) => {
                const full = `${s.firstName || ""} ${
                   s.lastName || ""
                }`.trim();
                const phone = s.phone || "";
                const email = s.email || "";
                return (
                   <li
                      key={s.id}
                      className="editReservationPopup__search-item"
                      onClick={() => {
                         c.setStudentId(String(s.id));
                         c.setView("form");
                      }}
                   >
                      <h3>{c.highlightText(full, c.qStudent)}</h3>
                      {phone && <p>{c.highlightText(phone, c.qStudent)}</p>}
                   </li>
                );
             })}
          </ul>
       </div>
    </div>
  );
}
